export default __webpack_public_path__ + "9c2eda56f7f1d7d1c5b3e8ffe982a5bb.svg";